import AWSService from '../services/AWSService';
import Mime from 'mime-types';

export class File {
  #fileUrl = String;
  #audioTypes = ['audio/mpeg', 'audio/ogg', 'audio/wav'];
  #videoTypes = ['video/mp4', 'video/webm', 'video/ogg'];
  #imageTypes = [
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/apng',
    'image/svg+xml',
    'image/x-icon',
    'image/webp',
    'image/bmp'
  ];
  url = String;
  blob = Blob;
  title = String;
  type = String;
  extension = String;

  constructor(hostUrl, fileUrl, type, buffer) {
    this.#fileUrl = fileUrl;
    this.url = `https://${hostUrl}/${fileUrl}`;
    this.blob = (window.URL || window.webkitURL).createObjectURL(new Blob([buffer], { type }));
    this.title = fileUrl.split('/').pop();
    this.type = type;
    this.extension = fileUrl.split('.').pop();
  }

  get isTypeCorrespondsToExtension() {
    return Mime.lookup(this.#fileUrl) === this.type;
  }

  get isSupportedAudio() {
    return this.#audioTypes.includes(this.type);
  }

  get isSupportedVideo() {
    return this.#videoTypes.includes(this.type);
  }

  get isSupportedImage() {
    return this.#imageTypes.includes(this.type);
  }

  get isSupportedFile() {
    return this.isSupportedImage || this.isSupportedAudio || this.isSupportedVideo;
  }

  static async getFromAWS(hs) {
    const contentList = await AWSService.getObjectsListByHash(hs);
    const content = await AWSService.getObject(contentList.Contents[0].Key);
    return new File(contentList.Name, contentList.Contents[0].Key, content.ContentType, content.Body);
  }
}
